<template>

  <div id="redoc-container"></div>

</template>

<script>
import apidoc from '../../public/japauto-ws-rdv-apidoc.json'
import * as redoc from 'redoc/bundles/redoc.standalone'

export default {
  name: 'WsRdv',
  data() {
  return {
    apidoc,
    redocOptions: {
      hideDownloadButton: true,
      scrollYOffset: 0

    }
  }
},
mounted() {
  redoc.init(apidoc, this.redocOptions, document.getElementById('redoc-container'))
}
}
</script>